import api from '../..'

const answerTaskDestroy = (fileId: string) => {
  return api.delete(`answers/attachments/${fileId}`)
}

export default answerTaskDestroy
